import React , {useState , useEffect } from 'react';
import webapi from '../../../api/webapi';

const SurfResultImageSelectBar = (props) =>{
    
    const [item, setItem] = useState(undefined)
    //const [modalshow, setModalshow] = useState(false)
    const [bookVersionList, setBookVersionList] = useState(undefined)
    //const [bookVersionListData, setBookVersionListData] = useState(undefined)

    useEffect(() => {
        props.setItem('')
        async function UpdateBookVersionList() {
            props.setLoadingShow(true)
            //setBookVersionListData('');
            await webapi.get('book/bookversionlist/' + props.selectedBook + '/' + props.selectedChapter)
                .then(response => {
                    setBookVersionList(response.data);
                    if  (response.data && response.data.length>0)
                    {   
                        setItem(response.data[0].Code)
                        props.setItem(response.data[0].Code)
                    }
                }) 

            props.setLoadingShow(false)
        }
        UpdateBookVersionList();
    }, [props.selectedChapter]);
    
    const onTextChange = event=> {
        setItem(event.target.value);
        props.setItem(event.target.value);
        //setBookVersionListData('');
    }

    const onTextKeyPress = event => {
        if (event.nativeEvent.key === "Enter" && item) {
            event.preventDefault();
            props.onSearchButtonClick(event);
        }
    }

    return (
        <div className="fullwidth_div">
            <br />
            <select style={{width:'calc(50% - 30px)',direction:'inherit',margin:'0px 15px',marginRight: '25%',marginTop: '15px', float: 'right'}}
                id="item" 
                type="text" 
                className=""
                required="required" 
                value={item || ''} 
                onChange={onTextChange}
                onKeyPress={onTextKeyPress}
            >  
                {   
                    ((bookVersionList)&&(bookVersionList != null))
                    ?
                    (bookVersionList.map((bookVersion,i) =>
                        {
                            return  (
                                <option key={bookVersion.Code} value={bookVersion.Code}>{bookVersion.Title}</option> 
                            )
                        })
                    )
                    :
                    <option value="-1">-</option>       
                }                
            </select>
        </div>
    );
}

export default SurfResultImageSelectBar;